import { Component, h, Listen, Prop } from '@stencil/core';
import { Modal } from '../../../core/stores/ConfigStore';
import { configStore } from '../../../core/stores';
import debounce from 'lodash.debounce'

@Component({
  tag: 'hcl-sdk-modal-center',
  styleUrl: 'hcl-sdk-modal-center.scss',
  shadow: false,
})
export class HclSdkModalCenter {
  @Prop() modals?: Array<Modal | undefined>;

  onClose = ({ id, index }: { id?: string | number; index?: number }) => {
    if (!!id) {
      const indexModal = this.modals.findIndex(modal => modal?.id === id);
      this.modals[indexModal] = undefined;
    } else if (typeof index === 'number' && index > -1) {
      this.modals[index] = undefined;
    } else {
      this.modals = []; // clear all
    }
    configStore.setState({ modals: [...this.modals] });
  };

  closeLatestModal() {
    const modals = this.modals.slice(0, this.modals.length - 1);
    configStore.setState({modals})
  }

  debounceCloseLatestModal = debounce(this.closeLatestModal.bind(this), 200)

  @Listen('keydown')
  handleKeyDown(e) {
    if (e.key === 'Escape') {
      if (this.modals[this.modals.length - 1].closeOnEscapeKeydown) {
        this.debounceCloseLatestModal()
      }
    }
  }

  render() {
    if (!this.modals) {
      return null;
    }
    return this.modals.map((modal, index) => {
      if (!modal) {
        return null;
      }
      return (
        <hcl-sdk-modal
          modal={modal}
          closeModal={() => {
            this.onClose({ index });
          }}
        />
      );
    });
  }
}
